<template>
  <div
    :class="{
      'select-box-wrapper': true,
      'select-box-wrapper--inline': inline,
    }"
  >
    <div class="select-box-label">
      <slot name="label" />
    </div>
    <multiselect
      class="select-box"
      :searchable="searchable"
      :allow-empty="false"
      :show-labels="false"
      :value="selected"
      :options="options"
      :taggable="taggable"
      @tag="tag"
      @input="onSelect"
    >
      <template slot="singleLabel" slot-scope="props">
        <div class="lang-option lang-option-label">
          {{ props.option }}
        </div>
      </template>
      <template slot="option" slot-scope="props">
        <div class="lang-option">
          {{ props.option }}
        </div>
      </template>
    </multiselect>
  </div>
</template>

<script>
export default {
  name: "LanguageSelect",
  props: {
    options: {
      type: Array,
    },
    selected: {
      type: String,
      default: "",
    },
    onSelect: {
      type: Function,
    },
    inline: {
      type: Boolean,
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    taggable: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: Function,
      default: () => null,
    },
  },
};
</script>

<style>
.select-box.multiselect {
  min-height: 32px;
}
.select-box .multiselect__tags {
  background: none;
  border: none;
  min-height: 32px;
  box-sizing: border-box;
  padding-top: 0;
}

.select-box .multiselect__single {
  background: none;
  height: 32px;
  margin: 0;
  line-height: 32px;
}
.select-box .multiselect__select {
  height: 32px;
  box-sizing: border-box;
}

.select-box .multiselect__select:before {
  border-color: #fff transparent transparent;
}

.select-box .multiselect__content-wrapper {
  border: none;
  background: none;
  margin: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.select-box .multiselect__option {
  background: #152a35;
}
.multiselect__input {
  background: transparent;
  color: #fff;
  margin: 0;
  height: 32px;
  padding: 0;
}
.multiselect__input::placeholder {
  color: #fff;
}
.multiselect__option--highlight:after {
  left: 0;
  background: #344048;
}
</style>

<style scoped>
.select-box-wrapper {
  width: 100%;
  margin: 12px 0 8px;
}
.select-box-wrapper--inline {
  display: flex;
  align-items: center;
}
.select-box-wrapper--inline .select-box-label {
  margin-right: 12px;
  margin-bottom: 0;
}

.select-box {
  width: 100%;
  outline: none;
  height: 32px;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 14px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
}

.lang-option {
  display: flex;
  align-items: center;
  font-size: 10px;
  font-weight: bold;
  transition: color 0.3s ease-in;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
}

.lang-option-label,
.lang-option:hover {
  color: #fff;
}

.select-box-label {
  margin-bottom: 8px;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.8);
}
</style>
